import React from 'react'
import { ExpandMore as ExpandMoreBase } from '@mui/icons-material'
import { styled } from '@mui/material'
import { Card, Typography } from '@chilecompra/react-kit'

export const Root = styled('section')`
  margin-top: 20px;
  width: 100%;
`
export const ContainerCard = styled(props => <Card color="blank" enableBorder {...props} />)`
  margin: ${props => props.margin || '20px 0 !important'};
  max-width: ${props => props.maxWidth || '100%'};
`
export const Anchor = styled('div')`
  border-bottom: 2px solid ${props => props.theme.palette.brand.black1};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`
export const AnchorText = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0 16px 0 0;
  pointer-events: none;
  user-select: none;
`
export const AnchorIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black1};
    font-size: 24px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`
export const Strong = styled('span')`
  font-weight: bold;
`

export const CardWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: space-between;
  border-radius: 8px;
  background-color: white;
  flex-wrap: wrap;

  @media (max-width: 1108px) {
    flex-direction: column;
  }
`

export const LeftColumn = styled('div')`
  max-width: 200px;
  flex: 1;
`

export const RightColumn = styled('div')`
  flex: 2;
`

export const IndicatorValue = styled(({ children, ...props }) => (
  <Typography fontWeight="bold" {...props}>
    {children}
  </Typography>
))`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 32px;
  font-weight: bold;
  margin: 8px 0;

  && span {
    font-size: 27px;
  }
`

export const Divider = styled('div')`
  height: auto;
  width: 1px;
  background-color: #d1d8e0;
  margin: 0 16px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const Footer = styled(Typography)`
  margin-top: 24px;
  font-size: 14px;
  color: #6b7280;
`

export const FormulaWrapper = styled('div')`
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 24px;
  margin-top: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

export const Line = styled('div')`
  height: 2px;
  background-color: #d1d5db;
  min-width: 460px;
  width: 100%;
  margin: 10px auto;
`
export const SelectorsContainer = styled('div')`
  width: 100%;
  margin: 10px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: 1108px) {
    flex-direction: column;
  }
`
export const DownloadButtonContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
`

export const DimensionsChartContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const DimensionsChartContent = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 32px;
  width: 100%;

  @media (max-width: 1108px) {
    flex-direction: column;
  }
`

export const ChartColumn = styled('div')`
  flex: 2;
  min-width: 0;
  margin-top: 40px;
`

export const FiltersColumn = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 280px;
  max-width: 320px;
  margin-top: 100px;

  @media (max-width: 1108px) {
    margin-top: 40px;
    max-width: 100%;
  }
`

export const AverageScoreCard = styled(props => <Card color="blank" enableBorder={props.enableBorder} {...props} />)`
  padding: 10px 20px;
  margin-top: 20px;
`

export const AverageScoreValue = styled(Typography)`
  && {
    font-size: 28px;
    font-weight: bold;
    color: ${props => props.theme.palette.brand.primary};
    margin: 0;
    padding: 0;
    position: absolute;
    top: -20px;
    background-color: white;

    span {
      font-size: 20px;
    }
  }
`

export const AverageScoreLabel = styled(Typography)`
  && {
    font-size: 14px;
    color: ${props => props.theme.palette.brand.body2 || '#2E384D'};
    margin: 8px 0 0;
    padding: 0;
    line-height: 1.4;
  }
`

export const DimensionsChartFooter = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  flex-wrap: wrap;
  gap: 16px;
`

export const FooterText = styled(Typography)`
  && {
    font-size: 14px;
    color: ${props => props.theme.palette.brand.body2 || '#768AA2'};
    margin: 0;
    padding: 0;
  }
`
export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`
export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  margin: ${props => props.margin};
  width: 82px;
`
